/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { Form, Errors } from 'react-redux-form';
import { find } from 'lodash';
import SearchableSelect from '../../../components/common/form/elements/searchable-select';
import ArrowButton from '../../../components/common/button-arrow';
import NumberOfPacksSold from '../../../components/submissions/postcode-plan/number-of-packs-sold';
import { getFilteredPostcodePlanObjectives } from '../../../actions/postcode-plan-objectives';

class PostcodePlanForm extends Component {
  state = {
    stores: []
  };

  componentWillReceiveProps(nextProps) {
    const { meta } = nextProps;

    if (this.state.stores.length === 0) {
      this.setState({
        stores: meta.outlets
      });
    }
  }

  componentWillMount() {
    this.setState({ stores: this.props.meta.outlets });
  }

  componentDidUpdate(prevProps) {
    const { formData: { outlet_id }, dispatch } = this.props;

    if (outlet_id !== prevProps.formData.outlet_id) {
      dispatch(getFilteredPostcodePlanObjectives(outlet_id));
    }
  }

  handlePostcodeplanChange = (e) => {
    const postcodeplan_objective = find(this.props.meta.postcodeplan_objectives, { value: e });
    this.setState({ stores: postcodeplan_objective.outlets });
  };

  findPostcodeplanObjective = (postcodeplanObjectivesId) => {
    const { filteredPostcodePlanObjectives } = this.props;
    const postcodeplanObjective = filteredPostcodePlanObjectives.find(postcodeplanObjective =>
      postcodeplanObjective.value === postcodeplanObjectivesId
    );

    if (postcodeplanObjective) {
      return postcodeplanObjective;
    }
  };

  render() {
    const { model, formData, formValid, meta, onSubmit } = this.props;
    const { outlet_id, postcodeplan_objectives_id } = formData;
    const isOutletAndPostcodeSelected = outlet_id !== '' && postcodeplan_objectives_id !== '';
    const postcodeplanObjective = this.findPostcodeplanObjective(postcodeplan_objectives_id);

    return (
      <div className="mg-bottom-60 mg-top-10">
        <div className="container-fluid padding-flush">
          <Form
            model={model}
            onSubmit={onSubmit}
            className="sell-it-submissions-tabs-epos-form"
            validators={
              {
                '': vals => (vals.categories && !Object.values(vals.categories).every(value => +value === 0)) ||
                (vals.brands && !Object.values(vals.brands).every(value => +value === 0))
              }
            }
          >
            <Row>
              <Col md={6} xs={12}>
                <Row>
                  <Col md={12}>
                    <Errors model={model} className="errors" />
                  </Col>
                  <Col md={12}>
                    <SearchableSelect
                      label='Outlet Name'
                      model={`${model}.outlet_id`}
                      options={this.state.stores}
                      value={outlet_id}
                      required
                    />
                  </Col>
                  <Col md={12}>
                    <SearchableSelect
                      label='Postcode Plan Objective'
                      model={`${model}.postcodeplan_objectives_id`}
                      options={meta.postcodeplan_objectives}
                      value={postcodeplan_objectives_id}
                      onChange={this.handlePostcodeplanChange}
                      required
                    />
                  </Col>
                </Row>
                {isOutletAndPostcodeSelected && postcodeplanObjective ?
                  <div>
                    <NumberOfPacksSold
                      model={model}
                      evidenceType={find(postcodeplanObjective.outlets, { value: outlet_id } ).evidence_type}
                      brands={postcodeplanObjective.brands}
                      categories={postcodeplanObjective.categories}
                    />
                    <Row>
                      <Col md={12} className="sell-it-submissions-tabs-epos-form-buttons">
                        <ArrowButton className="pull-right" arrow={false} disabled={!formValid} submit>
                          Submit
                        </ArrowButton>
                      </Col>
                    </Row>
                  </div> :
                  <Row>
                    <Col md={12} className="warning">
                      Please select an outlet and Postcode Plan Objective
                    </Col>
                  </Row>
                }
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.postcodePlanObjective,
  formValid: state.deep.forms.postcodePlanObjective.$form.valid,
  filteredPostcodePlanObjectives: state.postcodePlanObjectives.filteredPostcodePlanObjectives
});

export default connect(mapStateToProps)(PostcodePlanForm);



// WEBPACK FOOTER //
// ./src/components/submissions/postcode-plan/postcode-plan-form.jsx